import { IRideService } from './interfaces'
import {
  GetRideHistoryUseCase,
  GetDashboardDataUseCase,
} from '../useCases/RideUseCases'
import {
  GetRideHistoryUseCaseRequest,
  GetDashboardDataUseCaseRequest,
} from '../useCases/interfaces'
import { Result, isOk, createOk } from '@/shared/utils/Result'
import { RideAggregates } from '@/core/domain/entities/Ride'

export class RideService implements IRideService {
  constructor(
    private readonly getRideHistoryUseCase: GetRideHistoryUseCase,
    private readonly getDashboardDataUseCase: GetDashboardDataUseCase
  ) {}

  async getRideHistory(
    request: GetRideHistoryUseCaseRequest
  ): Promise<Result<RideAggregates[], Error>> {
    return await this.getRideHistoryUseCase.execute(request)
  }

  async getDashboardData(request: GetDashboardDataUseCaseRequest): Promise<
    Result<
      {
        driverMetrics: import('../../domain/entities/Driver').DriverAggregates
        rideMetrics: import('../../domain/entities/Ride').RideAggregates
      },
      Error
    >
  > {
    const result = await this.getDashboardDataUseCase.execute(request)
    if (isOk(result)) {
      const data = result.value
      return createOk({
        driverMetrics: data.driverAggregates,
        rideMetrics: data.rideAggregates,
      })
    }

    return result
  }
}
